import { render, staticRenderFns } from "./ModalReglamento.vue?vue&type=template&id=6982fd44&scoped=true"
import script from "./ModalReglamento.vue?vue&type=script&lang=js"
export * from "./ModalReglamento.vue?vue&type=script&lang=js"
import style0 from "./ModalReglamento.vue?vue&type=style&index=0&id=6982fd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982fd44",
  null
  
)

export default component.exports